import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import { HOME } from "@/data/homeContent";

export function ProblemSection() {
  const p = HOME.problem;
  return (
    <section id="problem" className="bg-ink-950 px-6 py-16 md:py-24" data-testid="home-problem">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={p.eyebrow} title={p.headline} testId="home-problem-heading" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 md:mt-16">
          {p.items.map((item, i) => (
            <Reveal key={item.num} delay={i * 0.08} className="h-full">
              <div className="h-full rounded-lg border border-line bg-ink-900/60 p-7" data-testid={`home-problem-${item.num}`}>
                <span aria-hidden="true" className="font-display text-2xl font-semibold text-transparent [-webkit-text-stroke:1px_rgba(154,167,181,0.5)]">
                  {item.num}
                </span>
                <h3 className="mt-4 font-display text-lg font-medium text-fg md:text-xl">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-fg-muted md:text-base">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function EnemySection() {
  const e = HOME.enemy;
  return (
    <section id="enemy" className="bg-ink-900 px-6 py-16 md:py-24" data-testid="home-enemy">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16">
        <div>
          <SectionHeader align="left" eyebrow={e.eyebrow} title={e.headline} testId="home-enemy-heading" />
          <Reveal delay={0.12}>
            <p className="mt-6 text-base leading-relaxed text-fg-muted md:text-lg">{e.body1}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-base leading-relaxed text-fg-muted md:text-lg">{e.body2}</p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="self-center">
          <div className="rounded-lg border border-line bg-ink-950/60 p-7" data-testid="home-standard-card">
            <h3 className="font-display text-lg font-medium uppercase tracking-[0.08em] text-brand-light">
              {e.standardTitle}
            </h3>
            <ul className="mt-5 space-y-3">
              {e.standard.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-fg-muted">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-brand" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function MethodSection() {
  const m = HOME.method;
  return (
    <section id="method" className="bg-ink-950 px-6 py-16 md:py-24" data-testid="home-method">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={m.eyebrow} title={m.headline} support={m.support} testId="home-method-heading" />
        <div className="mt-12 grid gap-5 md:mt-16 md:grid-cols-5 md:gap-4">
          {m.stages.map((stage, i) => (
            <Reveal key={stage.num} delay={i * 0.08} className="h-full">
              <div
                className="flex h-full flex-col rounded-lg border border-line bg-ink-900/60 p-6"
                data-testid={`home-stage-${stage.num}`}
              >
                <span aria-hidden="true" className="font-display text-3xl font-semibold text-brand">
                  {stage.num}
                </span>
                <h3 className="mt-3 font-display text-base font-medium uppercase tracking-[0.06em] text-fg md:text-lg">
                  {stage.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-fg-muted">{stage.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function BuildSection() {
  const b = HOME.build;
  return (
    <section id="value" className="bg-ink-900 px-6 py-16 md:py-24" data-testid="home-build">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={b.eyebrow} title={b.headline} support={b.support} testId="home-build-heading" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-16">
          {b.items.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 0.06} className="h-full">
              <div className="h-full rounded-lg border border-line bg-ink-950/60 p-6" data-testid={`home-build-${i + 1}`}>
                <h3 className="font-display text-base font-medium text-fg md:text-lg">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-fg-muted">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}